export default function Location() {
  return (
    <div className="location-wrapper">
      <div className="location">
        <iframe
          title="Innovation Academy Location"
          src="https://www.google.com/maps/d/embed?mid=1VDfODqv-a32ftvP4VuUlt3GRdaf1DmQ&ehbc=2E312F"
          width="600"
          height="450"
          style={{
            width: "100%",
            border: 0,
            filter: "grayscale(100%) ",
          }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}
